import { EnvironmentContext } from "components/Environment/EnvironmentContext";
import DropdownMenuEllipsis from "ds/components/DropdownMenu/Ellipsis";
import DropdownMenuItem from "ds/components/DropdownMenu/Item";
import useTypedContext from "hooks/useTypedContext";

import { showEnvVariableFormDrawer } from "../../EnvVariablesDrawer/EnvVariablesFormDrawer";
import { showDeleteConfirmation } from "../../VariableDeleteConfirmation/VariableDeleteConfirmation";
import EnvironmentTableCell from "../Cell";
import { EnvironmentVariableCellProps } from "./types";

const EnvVariableActionsCell = ({ item, ...cellProps }: EnvironmentVariableCellProps) => {
  const { onDelete, onUpdate, canDeleteVariables, canCreateAndEditVariables } =
    useTypedContext(EnvironmentContext);

  const variable = item.element;
  const canBeEdited = !(variable.runtime || item.context);

  const hasEditAction =
    canBeEdited && (canCreateAndEditVariables.result || !!canCreateAndEditVariables.message);
  const hasOverrideAction =
    !canBeEdited && (canCreateAndEditVariables.result || !!canCreateAndEditVariables.message);
  const hasDeleteAction =
    canBeEdited && (canDeleteVariables.result || !!canDeleteVariables.message);

  const hasAnyAction = hasEditAction || hasOverrideAction || hasDeleteAction;

  return (
    <EnvironmentTableCell {...cellProps}>
      {hasAnyAction && (
        <DropdownMenuEllipsis tooltip="Environment variable actions">
          {hasEditAction && (
            <DropdownMenuItem
              isDisabled={!canCreateAndEditVariables.result}
              tooltip={canCreateAndEditVariables.message}
              onAction={() =>
                showEnvVariableFormDrawer({ id: variable.id, variable, onSubmit: onUpdate })
              }
            >
              Edit variable
            </DropdownMenuItem>
          )}
          {hasOverrideAction && (
            <DropdownMenuItem
              isDisabled={!canCreateAndEditVariables.result}
              tooltip={canCreateAndEditVariables.message}
              onAction={() =>
                showEnvVariableFormDrawer({ id: variable.id, variable, onSubmit: onUpdate })
              }
            >
              Override
            </DropdownMenuItem>
          )}
          {hasDeleteAction && (
            <DropdownMenuItem
              isDisabled={!canDeleteVariables.result}
              tooltip={canDeleteVariables.message}
              onAction={() => showDeleteConfirmation({ id: variable.id, onDelete })}
              danger
            >
              Delete
            </DropdownMenuItem>
          )}
        </DropdownMenuEllipsis>
      )}
    </EnvironmentTableCell>
  );
};

export default EnvVariableActionsCell;
